import { render, staticRenderFns } from "./tripsTable.vue?vue&type=template&id=2a449c24&"
import script from "./tripsTable.vue?vue&type=script&lang=js&"
export * from "./tripsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports